<h2>Cambiar contraseña</h2>

<form [formGroup]="form"> 
<mat-dialog-content>
    <table>   
        <tr>
            <td><p style="width: 40%;
                vertical-align: top;
                padding-top: 0.3em;
                text-align: left;
                font-family: 'Montserrat', sans-serif;
                font-size: 14px;
                letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;
                font-weight: bold;">Contraseña actual:</p></td>
            <td>
                <mat-form-field>
                    <input matInput  type="password" formControlName="antigua" required (ngModelChange)="validarIncorrecta()">
                    <p class="mat-error p-error" *ngIf="incorrecta">
                        La contraseña enviada no corresponde
                    </p>
                    <mat-error *ngIf="form.hasError('required', 'antigua')">
                        Contraseña actual es requerida
                    </mat-error>
                    
                </mat-form-field>  
            </td>
        </tr>        
        <tr>
            <td><p style="width: 40%;
                vertical-align: top;
                padding-top: 0.3em;
                text-align: left;
                font-family: 'Montserrat', sans-serif;
                font-size: 14px;
                letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;
                font-weight: bold;">Nueva contraseña:</p></td>
            <td>
                <mat-form-field>
                    <input matInput  type="password" formControlName="password" required>
                    <mat-error *ngIf="form.hasError('required', 'password')">
                        Nueva contraseña es requerida
                    </mat-error>
                </mat-form-field>
            
            </td>
        </tr> 
        <tr>
            <td><p style="width: 40%;
                vertical-align: top;
                padding-top: 0.3em;
                text-align: left;
                font-family: 'Montserrat', sans-serif;
                font-size: 14px;
                letter-spacing: 0px;
                color: #4C4D55;
                opacity: 1;
                font-weight: bold;">nueva contraseña:</p></td>
            <td>
                <mat-form-field>
                    <input matInput  type="password" formControlName="confirmPassword" [errorStateMatcher]="matcher">
                      <mat-error *ngIf="form.hasError('notSame')">
                        No coinciden.
                    </mat-error>  
                </mat-form-field> 
            </td>
        </tr> 
    </table>  

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="btn-cancelar">Cancel</button>
    <button mat-button (click)="confirmar()" class="btn-confirmar" [disabled]="!form.valid">Aceptar</button>
  </mat-dialog-actions>
</form>